<template>
<div class="bg_ani">
    <div class="full-screen">
        <div>
            <h1>LEGO Enterprise</h1>

        </div>
    </div>
</div>
</template>
<script>
  /*global http*/
  export default {
    name: 'PGE_CMP_00029',
    data() {
      return {
       
      };
    },
    watch: {
      
    },
    computed: {
      
    },
    mounted() {},
  };
</script>




</style>
